var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./HoganAverageScore.module.scss";
export var HoganAverageScore = function (_a) {
    var _b;
    var average = _a.average, _c = _a.steps, steps = _c === void 0 ? 5 : _c;
    if (isNaN(average)) {
        return _jsx(_Fragment, {});
    }
    var stepPercentage = 100 / steps;
    var getBoxFill = function (boxIndex) {
        var boxStart = boxIndex * stepPercentage;
        var boxEnd = (boxIndex + 1) * stepPercentage;
        if (average <= boxStart) {
            return 0;
        }
        if (average >= boxEnd) {
            return 100;
        }
        return ((average - boxStart) / stepPercentage) * 100;
    };
    var getBubbleStyle = function () {
        if (average <= 0) {
            return {
                left: "0%",
                transform: "translate(0%, -50%)",
            };
        }
        else if (average >= 100) {
            return {
                left: "100%",
                transform: "translate(-100%, -50%)",
            };
        }
        else {
            return {
                left: "".concat(average + 2.5, "%"),
                transform: "translate(-50%, -50%)",
            };
        }
    };
    var bubbleStyle = getBubbleStyle();
    return (_jsxs("div", __assign({ className: styles.hoganAverageMainContainer }, { children: [_jsx("div", __assign({ className: styles.hoganAverageContainer }, { children: Array.from({ length: steps }).map(function (_, index) { return (_jsx("div", __assign({ className: styles.averageScoreSteps }, { children: _jsx("div", { className: styles.averageScoreFill, style: {
                            width: "".concat(getBoxFill(index), "%"),
                        } }) }), index)); }) })), _jsxs("div", __assign({ className: styles.averageBubble, style: __assign({ position: "absolute" }, bubbleStyle) }, { children: [(_b = average === null || average === void 0 ? void 0 : average.toFixed(0)) !== null && _b !== void 0 ? _b : "", "%"] }))] })));
};
